import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Skeleton } from 'primereact/skeleton';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FilterMatchMode } from 'primereact/api';
import Layout from '../../../Layout';
import fontConfig from '../../../../Componentes/FontConfig';
import { useLocation } from 'react-router-dom';
import { OverlayPanel } from 'primereact/overlaypanel';
import { SplitButton } from 'primereact/splitbutton';
import { Toast } from 'primereact/toast';
import { FileUpload } from 'primereact/fileupload';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { Tooltip } from 'primereact/tooltip';
import { Divider } from 'primereact/divider';
import { Tag } from 'primereact/tag';
import { InputSwitch } from "primereact/inputswitch";
import { SpeedDial } from 'primereact/speeddial';
import { ProgressSpinner } from 'primereact/progressspinner';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Chip } from 'primereact/chip';
import { RadioButton } from 'primereact/radiobutton';
import { Badge } from 'primereact/badge';
import { Slider } from "primereact/slider";
import IconeDesktop from './imagens/iconeDesktop.png'
import IconeNote from './imagens/iconeNotebook.png'
import IconeVM from './imagens/iconeVirtualMachine.png'
import { Menu } from 'primereact/menu';
import { useNavigate } from 'react-router-dom';  // Importar useNavigate
import { MultiSelect } from 'primereact/multiselect';
import ConexaoInventory from '../../../../providers/ConexaoInventory'
import Conexao from '../../../../providers/Conexao';
import { Calendar } from 'primereact/calendar';
import SidebarInventory from './SidebarInventory';
import VisaoParqueInventoryMaps from './VisaoParqueInventoryMaps';
export default function VisaoParqueInventory(props) {
//https://www.instagram.com/p/DDfk8RDRYpE/?img_index=1

    const toast = React.useRef(null); // Ref para o Toast
    const [ingredient, setIngredient] = useState('parque');
    const [selectedCores, setSelectedCores] = useState(null);
    const [visible, setVisible] = useState({
        visible : false, 
        alerta : []
    });

     const navigate = useNavigate(); 
    const [coleta, setColeta] = useState([])
    const [loading, setLoading] = useState(false);

    const [coletas, setColetas]= useState([]);
    
    const [selectedColetas, setSelectedColetas]= useState([]);
    
    const [selectAll, setSelectAll] = useState(false);

    const [fieldsFound, setFieldsFound] = useState([]);

    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [parametroData, setParametroData] = useState(['',''])
    
    const location = useLocation();

    const { dataEmpresa, disabledItemMenu } = location.state || {};

    const op = useRef(null); // Referência para o OverlayPanel
    const [openFilter, setOpenFilter] = useState(false)
    const requisicaoInicialData = useRef(false); // Referência para o botão de filtro

    const [totalRegistros, setTotalRegistros] = useState(0)
    const [diasPesquisa, setDiasPesquisa] = useState([0,999])

    const [faixaTonerPreto, setFaixaTonerPreto] = useState([0,100])
    const [verCorPreta, setVerCorPreta] = useState(true)
    const [verCorCiano, setVerCorCiano] = useState(true)
    const [verCorMagenta, setVerCorMagenta] = useState(true)
    const [verCorAmarelo, setVerCorAmarelo] = useState(true)
    const [dias, setDias] = useState([1, 365])
    const [openPrevisao, setOpenPrevisao] = useState([])
    const [dataInicial, setDataInicial] = useState('')
    const [dataFinal, setDataFinal] = useState('')
    const [dataInventory, setDataInventory]= useState([])
    const [dataInventoryFiltrados, setDataInventoryFiltrados]= useState([])
    const [openSidebar, setOpenSidebar] = useState(false)
        const [detalhesInventory, setDetalhesInventory] = useState([])
    
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        idempresa: { value: '', matchMode: FilterMatchMode.EQUALS },
        numeroserie: { value: '', matchMode: FilterMatchMode.CONTAINS },
        modelo: { value: '', matchMode: FilterMatchMode.CONTAINS },
        marca: { value: '', matchMode: FilterMatchMode.CONTAINS },
         
       
    });
    const [contadorErros, setContadorErros] = useState(0)

 useEffect(() => {
        if(!requisicaoInicialData.current){
            getData();
            requisicaoInicialData.current = true
        }else{

        }
       
    }, []);



    const getData = () => {
        clearFilters();
        setLoading(true);

        ConexaoInventory.post('InventoryController/getShortedAll?idusuario='+dataEmpresa.idrevenda+'&idempresa='+dataEmpresa.idempresa+'&idcliente='+(dataEmpresa.idcliente  ? dataEmpresa.idcliente : -1), {
            idempresa: dataEmpresa.idempresa,
            idcliente: dataEmpresa.idcliente ? dataEmpresa.idcliente : -1,
            fullData: 't'
        })
        .then(response => {
            if (response.status === 200 && response.data.status === 'OK') {
                const temp = [];
                setDataInventory(response.data.payload)
                for (let i = 0; i < response.data.payload.length; i++) {
                    temp.push({
                        index: i,
                        hostname: response.data.payload[i].hostName,
                        devicetype: response.data.payload[i].typeDevice,
                        dominio: response.data.payload[i].domainName,
                        sistemaoperacional: response.data.payload[i].OperatingSystem?.Name ?? '',
                        modelo: response.data.payload[i].Modelo?.Model ?? '',
                        fabricante: response.data.payload[i].Modelo?.Manufacturer ?? '',
                        serial: response.data.payload[i].Bios?.SerialNumber ?? '',
                        dataatualizacao : response.data.payload[i].dataAtualizacao, 
                        razaosocial : response.data.payload[i].razaoSocial, 
                        ativo : response.data.payload[i].coletaAtiva, 
                        patrimonio : response.data.payload[i].patrimonio, 
                        modeloalternativo : response.data.payload[i].modeloAlternativo,
                        chavedca : response.data.payload[i].chaveDca, 
                        Posicao : response.data.payload[i].Posicao, 
                        Modelo : response.data.payload[i].Modelo, 
                        OperatingSystem : response.data.payload[i].OperatingSystem, 
                        dataAtualizacao : response.data.payload[i].dataAtualizacao, 
                        chaveDca : response.data.payload[i].chaveDca,
                        _id : response.data.payload[i]._id, 
                        hostName : response.data.payload[i].hostName, 
                        razaoSocial : response.data.payload[i].razaoSocial, 
                    

                    });
                }

            
                setColetas(temp);
                setDataInventoryFiltrados(temp)
                setContadorErros((prevStatus)=>0)
            } else {
                //setDataInventory([])
            // setColetas([]);
            setContadorErros((prevStatus)=> prevStatus + 1)
            if(contadorErros === 3){
                    setDataInventory([])
                    setColetas([]);
                    setContadorErros((prevStatus)=>0)
            }
            }

            setLoading(false);
        })
        .catch(error => {
        setContadorErros((prevStatus)=> prevStatus + 1)
            if(contadorErros === 3){
                    setDataInventory([])
                    setColetas([]);
                    setContadorErros((prevStatus)=>0)
                    showMessageToast('error', "Não foi possível recuperar dados");
            }
            setLoading(false);
        // showMessageToast('error', "Não foi possível recuperar dados");
        });
    };
const  renderClasse = (dataatualizacao) => {
        // Converte a data de entrada para o objeto Date
        const data1 = new Date(dataatualizacao);

        const dataAtual = new Date(); // Data atual    
        // Calcula a diferença em milissegundos
        const diffMilissegundos =  dataAtual - data1;    
        // Convertendo a diferença
        const diffSegundos = Math.floor(diffMilissegundos / 1000); 
                  // Segundos
        const diffMinutos = Math.floor(diffSegundos / 60);    
                       // Minutos
        const diffHoras = Math.floor(diffMinutos / 60); 
                             // Horas
        const diffDias = Math.floor(diffHoras / 24);                        // Dias    
        // Calculando a diferença exata em cada unidade
        const diasRestantes = diffDias;

        const horasRestantes = diffHoras % 24;

        const minutosRestantes = diffMinutos % 60;

        const segundosRestantes = diffSegundos % 60;    
        // Retorna o resultado como uma string formatada
           
       // console.log("Data is not an array or is undefined.");
        return diasRestantes
    }

  const renderData = (data) =>{
        var teste = data.split('T')
        return teste[0]+' '+teste[1].substr(0,8)
    }
    const showMessageToast = (severity, msg) => {
        switch(severity){
            case "error":
                toast.current.show({
                    severity: "error",
                    summary: "Erro",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

            case "success":
                toast.current.show({
                    severity: "success",
                    summary: "Sucess",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

            case "warn":
                toast.current.show({
                    severity: "warn",
                    summary: "Warning",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

        }
        
      };


    const handleFilterChange = (e, field) => {

        const value = e.target.value;
        
        setFilters(prevFilters => ({
            ...prevFilters,
            [field]: { value, matchMode: FilterMatchMode.CONTAINS },
            
        }));
    };

    const [overlayVisible, setOverlayVisible] = useState(false);

    const handleFilterConfirm = () => {
        // Aqui você pode aplicar os filtros ao DataTable ou fazer outras ações necessárias
        setOverlayVisible(false); // Fecha o overlay após aplicar os filtros
    };

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        setGlobalFilterValue(value);
    
        // Atualizar o filtro global
        const _filters = { ...filters };
        _filters['global'].value = value;
        
       
        setFilters(_filters);
    
        // Identificar os campos onde o filtro foi encontrado
      
    };
    
 

    const menuRight = useRef(null);


    const renderTipoDispositivo = (typeDevice) =>{
        switch(typeDevice){
            case 'Desktop': return <img src ={IconeDesktop} width={48} style={{marginTop :'5px'}}/>;
            case 'Notebook': return <img src ={IconeNote}  width={48} style={{marginTop :'5px'}}/>;
            case 'Virtual Machine': return <img src ={IconeVM}  width={48} style={{marginTop :'5px'}}/>;
            default:return <img src ={IconeDesktop} width={48}/>;
        }
    }
    const renderHeader = () => {

        return (

            <React.Fragment>
                
            <div className="flex flex-wrap align-items-center" style={{paddingBottom : '10px', paddingTop : '10px', paddingLeft : '0px'}}>
                <div className="col-12 md:col-10">
                    <div className="flex flex-wrap align-items-center gap-5">
                        <div className='col-12 md:col-2 pl-2 pr-2 '>
                        <IconField iconPosition="left" className='w-full'>
                            <InputIcon className="pi pi-search" />
                            <InputText 
                                value={globalFilterValue} 
                                onChange={onGlobalFilterChange} 
                                disabled = {loading}
                                placeholder="Pesquisa global" 
                                tooltip="Pesquise por qualquer campo da tabela" tooltipOptions={{ position: 'bottom' }}
                            />
                            
                        </IconField>
                        </div>
                        
                        
                        <div className='col-12 md:col-1 pl-2 pr-2 gap-1'>
                            <div className='flex justify-content-around align-items-center gap-1'>
                         
                                <Button 
                                    icon="pi pi-filter-slash" 
                                    className="p-button-secondary p-button-sm" 
                                    onClick={clearFilters} 
                                    disabled = {loading}
                                    tooltip="Limpar todos os filtros" tooltipOptions={{ position: 'bottom' }}
                                />
                        
                                <Button 
                                    icon="pi pi-sync" 
                                    className= "p-button-primary p-button-sm " 
                                    onClick={getData} 
                                    disabled = {loading}
                                    tooltip="Buscar dados..." tooltipOptions={{ position: 'bottom' }}
                                /> 
                               <VisaoParqueInventoryMaps positions ={dataInventoryFiltrados.filter(item => item.ativo === 't')} dataEmpresa ={dataEmpresa}/>

                            </div>
                          
                         </div>           
                                
                    </div>
                    
                </div>
                
            </div>

            </React.Fragment>

        );
    };
    

    const renderFooter = () => {
        if (fieldsFound.length === 0) {
            return  <div className="w-10 text-left" style={{ fontSize: '10px', color: '#444' }}>
            Total de registros: {totalRegistros} 
        </div>
        }
        
        return <>
        <div className="w-10 text-left" style={{ fontSize: '10px', color: '#444' }}>
            Total de registros: {totalRegistros} 
        </div>
        <div className="w-10 text-left" style={{ fontSize: '10px', color: '#444' }}>
            Filtro encontrado em: {fieldsFound.join(', ')}
        </div>
    </>
    };

    const clearFilters = () => {
        setGlobalFilterValue('');
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            idempresa: { value: '', matchMode: FilterMatchMode.EQUALS },
            numeroserie: { value: '', matchMode: FilterMatchMode.CONTAINS },
            modelo: { value: '', matchMode: FilterMatchMode.CONTAINS },
            marca: { value: '', matchMode: FilterMatchMode.CONTAINS },    
            prtalertdescription : { value: '', matchMode: FilterMatchMode.CONTAINS },    
            datatroca :   {
                operator: 'and',
                constraints: [
                    { value: null, matchMode: FilterMatchMode.BETWEEN },
                    { value: null, matchMode: FilterMatchMode.BETWEEN }
                ]
            },
        });        
        setFieldsFound([]); // Resetando os campos encontrados
        setFaixaTonerPreto([0,100])
        setVerCorCiano(true)
        setVerCorMagenta(true)
        setVerCorAmarelo(true)
        setVerCorPreta(true)
        setDataInicial('')
        setDataFinal('')
        setDias([1,365])
    };



 const getOne = (chaveID) =>{
        ConexaoInventory.post('InventoryController/getOne?id='+chaveID, {

        }).then(response=>{
            if(response.status == 200 && response.data.status === 'OK'){
                setDetalhesInventory(response.data.payload)
            
                setOpenSidebar(true)
            }else{
                setDetalhesInventory([])
                setOpenSidebar(false)
            }
        }).catch(error =>{
            setDetalhesInventory([])
            setOpenSidebar(false)
        })
    }
    
    return (
        <Layout loading={loading}>
            <div className="p-2">
              

                <div className="border-round-lg surface-card shadow-0 p-2">
                    {/* Botão para abrir o OverlayPanel */}
                    
                
                        <DataTable
                            header={renderHeader()}  
                            footer={renderFooter} 
                            value={coletas}
                            paginator 
                            totalRecords={coletas.length}   
                            onValueChange={(filteredItems) => {                            
                                setDataInventoryFiltrados(filteredItems)
                            }}           
                            rows={25} // Número de itens por página
                            rowsPerPageOptions={[10, 15, 20, 25,50]} // Opções de páginas
                            responsiveLayout="scroll"
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                            tableStyle={{ minWidth: '35rem' }}
                            filters={filters} // Aplicando os filtros
                            filterDisplay="menu" // Exibe os filtros como menu pop-up
                            multiSortMeta={[
                                { field: "dataAtualizacao", order: 1},   // 1 = ascendente   // -1 = descendente
                            ]}
                            sortMode='single'>
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.small , width : '0.5%', paddingTop : '2px', paddingBottom : '2px' }} 
                                headerStyle={{ fontSize: fontConfig.small }} 
                                body={(row)=>loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' , }} /> : <> 
                                {row.ativo === 't' ? <SidebarInventory 
                                    dias = {renderClasse(row.dataatualizacao)}
                                    id = {dataInventory[row.index]._id}
                                    ativo ={ row.ativo}
                                />  :  <Tag severity="default" icon="pi pi-ban"></Tag> }                             
                               
                                    </>
                                } />
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.small , width : '5%', paddingTop : '2px', paddingBottom : '2px' }} 
                                headerStyle={{ fontSize: fontConfig.small }} 
                                field="hostname" 
                                header="Hostname" 
                                body={(row)=>loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : <span>{row.hostname}</span>
                                }
                                sortable                                  
                                filterPlaceholder="Filtrar pelo serial" />
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.small , width : '12%', paddingTop : '2px', paddingBottom : '2px' }} 
                                headerStyle={{ fontSize: fontConfig.small }} 
                                field="modelo" 
                                header="Modelo" 
                                body={(row)=>loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : 
                                <div>
                                    <span style={{fontSize :'0.9rem', fontWeight : 'bold'}}>{row.modelo}</span><br/>
                                    <span style={{fontSize :'0.7rem'}}>Serial: {row.serial}</span>
                                </div>
                                }
                                sortable                                  
                                filterPlaceholder="Filtrar pelo serial" />
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.small , width : '15%', paddingTop : '2px', paddingBottom : '2px' }} 
                                headerStyle={{ fontSize: fontConfig.small }} 
                                field="fabricante" 
                                header="Fabricante" 
                                body={(row)=>loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> :
                                <div>
                                    <span  style={{fontSize :'0.9rem', fontWeight : 'bold'}}>{row.fabricante}</span><br/>
                                    <span style={{fontSize :'0.7rem'}}>{row.sistemaoperacional}</span>    
                                </div>
                                }
                                sortable                                  
                                filterPlaceholder="Filtrar pelo serial" />
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.small , width : '18%', paddingTop : '2px', paddingBottom : '2px' }} 
                                headerStyle={{ fontSize: fontConfig.small }} 
                                field="razaosocial" 
                                header="Cliente" 
                                body={(row)=>loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : 
                                <div>
                                    <span  style={{fontSize :'0.8rem', fontWeight : 'bold'}}>{row.razaosocial}</span><br/>
                                </div>
                                }
                                sortable                                  
                                filterPlaceholder="Filtrar pelo serial" />

                            <Column 
                                bodyStyle={{ fontSize: fontConfig.small , width : '8%', paddingTop : '2px', paddingBottom : '2px' }} 
                                headerStyle={{ fontSize: fontConfig.small }} 
                                field="chavedca" 
                                header="DCA" 
                                body={(row)=>loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : 
                                <div>
                                    <span className='div-dca ' 
                                        onClick={()=>{
                                        if(disabledItemMenu) {
                                            
                                            return;
                                        }
                                            navigate('/cadastro-dcas', { state: { ...location.state, isMobile : props.isMobile, disabledItemMenu : disabledItemMenu, filter : {
                                                filtered : true, 
                                                chave : row.chavedca
                                            } } });
                                        }}>{row.chavedca}</span>    
                                </div>
                                }
                                sortable                                  
                                filterPlaceholder="Filtrar pelo serial" />
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.small , width : '5%', paddingTop : '2px', paddingBottom : '2px' }} 
                                headerStyle={{ fontSize: fontConfig.small }} 
                                header="Atualização" 
                                field='dataatualizacao'
                                body={(row)=>loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : 
                                
                                <span style={{fontSize :'0.7rem'}}>{renderData(row.dataatualizacao)}</span>
                                }
                                sortable                                  
                                filterPlaceholder="Filtrar pelo serial" />
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.small , width : '1%', paddingTop : '2px', paddingBottom : '2px' }} 
                                headerStyle={{ fontSize: fontConfig.small }} 
                                header="Status" 
                                body={(row)=>loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : 
                                row.ativo === 't' ? <Tag severity="success" value="ATIVO" style={{width : '100%', fontSize : '10px'}}></Tag> : <Tag severity="danger" value="INATIVO" style={{width : '100%', fontSize : '10px'}}></Tag>
                                }
                                sortable                                  
                                filterPlaceholder="Filtrar pelo serial" />

                                                
                        </DataTable>
                    
                </div>                
            </div>

            <OverlayPanel ref={op} style={{ width: '300px' }}>
                    <div className="p-3">
                        <h4>Filtros</h4>                                          
                        <div className="p-field">
                            <label htmlFor="razaosocial">Marca</label>
                            <InputText
                                id="marca"
                                value={filters.marca.value}
                                onChange={(e) => handleFilterChange(e, 'marca')}
                            />
                        </div>

                        <div className="p-field">
                            <label htmlFor="razaosocial">Modelo</label>
                            <InputText
                                id="modelo"
                                value={filters.modelo.value}
                                onChange={(e) => handleFilterChange(e, 'modelo')}
                            />
                        </div>                       
                        <Button label="Aplicar Filtro" icon="pi pi-check" onClick={handleFilterConfirm} />
                    </div>
                </OverlayPanel>
             <Toast ref={toast} />
            
            
        </Layout>
    );
}
